"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractLazyLoadService = void 0;
var default_configuration_1 = require("../config/default.configuration");
var dom_utils_1 = __importDefault(require("../utils/dom.utils"));
var errors_hander_1 = require("../utils/errors.hander");
var event_bus_1 = require("../../event-bus/event-bus");
var logger_utils_1 = require("../utils/logger.utils");
var AbstractLazyLoadService = /** @class */ (function () {
    /**
     * Constructor of AbstractLazyLoadService with common methods.
     *
     * @param errorHandler ErrorHandler instance by default value
     * @param configuration Configuration of Lazy-load; by default DefaultConfiguration constant
     * @protected
     */
    function AbstractLazyLoadService(configuration, errorHandler) {
        if (errorHandler === void 0) { errorHandler = new errors_hander_1.ErrorHandler(); }
        this.configuration = __assign(__assign({}, default_configuration_1.DefaultConfiguration), configuration);
        this.logger = logger_utils_1.Logger.getInstance();
        this.logger.setConfiguration(this.configuration);
        this.errorHandler = errorHandler;
        this.logger.debug('Lazy configuration details:', this.configuration);
        window[this.configuration.eventBus.name] = new event_bus_1.EventBus(this.configuration.eventBus.name);
    }
    AbstractLazyLoadService.prototype.triggerLazyLoad = function (placeholder) {
        return __awaiter(this, void 0, void 0, function () {
            var kobiFragmentId, htmlResponse, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        kobiFragmentId = placeholder.getAttribute(this.configuration.fragmentPlaceholderConfig.FragmentIdAttribute);
                        if (!kobiFragmentId) return [3 /*break*/, 2];
                        dom_utils_1.default.handleCSS(kobiFragmentId);
                        return [4 /*yield*/, this.callKobiEndpoint(placeholder)];
                    case 1:
                        htmlResponse = _a.sent();
                        this.handleResponse(kobiFragmentId, placeholder, htmlResponse);
                        return [3 /*break*/, 3];
                    case 2:
                        this.logger.warn("Fragment ID not found on placeholder to lazy-load.");
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        this.errorHandler.handle(error_1, placeholder);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AbstractLazyLoadService.prototype.callKobiEndpoint = function (placeholder) {
        return __awaiter(this, void 0, void 0, function () {
            var lazyUrl, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        lazyUrl = placeholder.getAttribute(this.configuration.fragmentPlaceholderConfig.lazyLoadUrlAttribute);
                        if (!lazyUrl) return [3 /*break*/, 2];
                        return [4 /*yield*/, fetch(lazyUrl)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.text()];
                        }
                        else {
                            return [2 /*return*/, Promise.reject("Response error to lazy-load fragment: " + response.statusText)];
                        }
                        return [3 /*break*/, 3];
                    case 2: return [2 /*return*/, Promise.reject("No Lazy URl found")];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AbstractLazyLoadService.prototype.handleResponse = function (kobiFragmentId, target, html) {
        this.logger.debug('Handle response of Fragment id ' + kobiFragmentId);
        var elementsInfo = dom_utils_1.default.handleHTML(html, target);
        dom_utils_1.default.handleJS(kobiFragmentId);
        window[this.configuration.eventBus.name].emit(this.configuration.eventBus.emittedEvent, { fragmentId: kobiFragmentId, dataLazyUuid: elementsInfo === null || elementsInfo === void 0 ? void 0 : elementsInfo.uuid, htmlElements: elementsInfo === null || elementsInfo === void 0 ? void 0 : elementsInfo.elementsList });
    };
    return AbstractLazyLoadService;
}());
exports.AbstractLazyLoadService = AbstractLazyLoadService;
//# sourceMappingURL=abstract-lazyload.service.js.map